import { injectIntl } from "react-intl";
import React from "react";

const Box = (props) => {

    return (
        <div className={ "Box" }>{props.name}</div>
    );
}

export default injectIntl(Box);
